export default {"src":"/_next/static/media/twitter.e78d0074.svg","height":67,"width":67,"blurWidth":0,"blurHeight":0};